import { PageHero } from '../components/sections/PageHero';
import { ContactForm } from '../components/sections/ContactForm';
import { ContactInfoSidebar } from '../components/sections/ContactInfoSidebar';
import { ContactWhatsAppCta } from '../components/sections/ContactWhatsAppCta';

export const ContactoPage = () => (
  <div className="pt-20" data-testid="contacto-page">
    <PageHero
      title="Contáctanos"
      subtitle="Estamos aquí para responder todas tus preguntas y ayudarte a comenzar."
    />

    <section className="py-20 md:py-28" data-testid="contact-content-section">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <ContactForm />
          <ContactInfoSidebar />
        </div>
      </div>
    </section>

    <ContactWhatsAppCta />
  </div>
);
